//*** Lib */

import { useEffect, useState } from "react";
import {
    createCookie,
    getCookie,
    isCookieExist,
    removeCookie,
    setCookie
} from "../utils/Cookies/CookieHandler";
import {
    removeData,
    getData
} from "../utils/LocalStorage/LocalStorageManager";
const authCookieName = 'AdminAuthUser';
const tokenCookieName = 'AdminToken';
const otpValidat = 'adminOtpValid';
const securityPermission = 'SecurityPermission';

export const setAuthProps = (data) => {
    const authProps = {
        cookieName: authCookieName,
        cookieValue: data,
        expirationTime: data.sessionTimeout
    }
    createCookie(authProps);
    setTokenProps(data.token);
}
// Set cookies after otp validation
export const setAuthPropsOnOTP = (data) => {
    if (data.valid) {
        let setAuthData = getData("authData")
        if (setAuthData.isAuthenticated) {
            const authProps = {
                cookieName: otpValidat,
                cookieValue: data,
                expirationTime: setAuthData.sessionTimeout
            }
            createCookie(authProps);
            setTokenProps(setAuthData.token);
        }
        else {
            signOut()
        }
    }
}

export const setSecurityPermission = (data, sessionTimeout) => {
    const authProps = {
        cookieName: securityPermission,
        cookieValue: data,
        expirationTime: sessionTimeout
    }
    createCookie(authProps);
}

export const getAuthProps = () => {
    return getCookie(authCookieName);
}

export const isAuthorized = () => {
    return isCookieExist(authCookieName);
}

export const setTokenProps = (data) => {
    const tokenProps = {
        cookieName: tokenCookieName,
        cookieValue: data
    }
    setCookie(tokenProps);
}

export const getTokenProps = () => {
    return getCookie(tokenCookieName);
}

export const signOut = () => {
    removeCookie(authCookieName, { path: '/' });
    removeCookie(tokenCookieName, { path: '/' });
    removeCookie(otpValidat, { path: '/' });
    // removeAllCookies();
    removeData("isPIC1");
    removeData("pic1Name");
    removeData("authData");
    removeData("isValidOTP");
    window.location.href = "/login";
}

export const InactivityDetector = (timeoutInMilliseconds) => {
    const [inactive, setInactive] = useState(false);
    // Declare inactivityTimer variable using let
    let inactivityTimer;

    // Function to reset the timer when there's activity
    const resetTimer = () => {
        clearTimeout(inactivityTimer);
        inactivityTimer = setTimeout(() => {
            setInactive(true);
        }, timeoutInMilliseconds);
    };

    useEffect(() => {
        const handleMouseMovement = () => resetTimer();

        window.addEventListener('mousemove', handleMouseMovement);
        window.addEventListener('keydown', handleMouseMovement);
        window.addEventListener('click', handleMouseMovement);

        // Start the initial timer
        resetTimer();

        return () => {
            window.removeEventListener('mousemove', handleMouseMovement);
            window.removeEventListener('keydown', handleMouseMovement);
            window.removeEventListener('click', handleMouseMovement);
            clearTimeout(inactivityTimer);
        };
    }, [timeoutInMilliseconds]);

    useEffect(() => {
        if (inactive) {
            signOut()
        }
    }, [inactive]);
};